import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectFetch, TYPES as UTIL_TYPES } from '@monofe/util';
import { injectMediaAPI, TYPES as API_TYPES } from '../../api/interface/bind';
import type { IWorkspaceDB } from '../../db/interface/db';
import { injectMediaCacheController } from '../../util/interface';
import { TYPES as CACHE_TYPES } from '../../util/interface/bind';
import type { IAuthenticationManager } from '../interface/auth';
import {
    bindMediaManager,
    injectMediaManager,
    TYPES as CONTROLLER_TYPES,
    unbindMediaManager,
} from '../interface/bind';
import type { IMediaManagerInstantiator } from '../interface/media';
import mediaManager from './media';

function _build(container: IContainer): Readonly<IMediaManagerInstantiator> {
    const mediaAPI = () => injectMediaAPI(container);
    const fetcher = injectFetch(container);
    const cacheController = injectMediaCacheController(container);

    return Object.freeze({
        open: (db: IWorkspaceDB, auth: IAuthenticationManager) =>
            mediaManager(db, auth, mediaAPI, fetcher, cacheController),
    });
}

export default buildBindable<IMediaManagerInstantiator>({
    id: CONTROLLER_TYPES.IMediaManager,
    dependencies: [API_TYPES.IMediaAPI, UTIL_TYPES.IFetch, CACHE_TYPES.IMediaCacheController],
    bind: bindMediaManager,
    remove: unbindMediaManager,
    build: container => Promise.resolve(_build(container)),
    inject: injectMediaManager,
});
